import styles from '../styles/details/id.module.scss';
import React, { useEffect, useState } from 'react'
import { createFontItem, getFontItem, getFontItemUrl } from '../../constants/api'
import {http} from '../../utils/api'
import Layout from '../../components/MyLayout'
import { NextPage, NextPageContext } from 'next';
import { Button, Card, Col, Descriptions, List, PageHeader, Popconfirm, Popover, Row, Slider, Space, Spin, Typography } from 'antd';
import { Down, Download, PreviewOpen, Time } from '@icon-park/react';
import { useSelector } from 'react-redux';
import { State } from '../../@types/reducer';
import TextArea from 'antd/lib/input/TextArea';
import Link from 'next/link';
import Meta from 'antd/lib/card/Meta';
import dynamic from 'next/dynamic';
import { Item } from '../../@types/font';
import { domain, title } from '../../constants/heads';
const { Title,Text } = Typography;
const SketchPicker = dynamic(
    import('../../components/NoSsr/SketchPicker'),
    { ssr: false }
)
type Props = {
    data: {
        data: Item,
        url: string
        list: Item[]
    }
}

const FontId: NextPage<Props> = (props) => {
    const { data, url, list } = props.data
    const [color, setColor] = useState('#000000');
    const [loading, setLoading] = useState(true);
    const [size, setSize] = useState(24);
    const [text, setText] = useState(data.title);
    const [image, setImage] = useState("");
    const { isXs, isSm, isMd, isXxl } = useSelector((state: State) => state.responsive)

    const head = {
        title: `${data.title}-${title}`,
        description: `${data.title}字体下载、${data.title}预览、${data.title}效果。${title}拥收录百款免费商用字体每个字体结果严格审核，在线实时预览、在线下载、无需安装字体直接使用。找免费商用字体就上${title}！`,
        keywords: `${data.title},${data.title}预览,${data.title}下载,${data.title}效果`
    }

    const colorChange = (color: { hex: React.SetStateAction<string>; }) => {
        setColor(color.hex)
    }
    const textChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setText(e.target.value)
    }
    const sizeChange = (value: any) => {
        setSize(value)
    }

    const getFont = async () => {
        setLoading(true)
        const res:any = await http(createFontItem, { id: data._id, text, size, color })
        if (res.code == 200) {
            setImage(res.data[0].image)
        }
        setLoading(false)
    }

    const downloadImg = async (scale: number) => {
        const saveSvgAsPng = (await import('save-svg-as-png'))
        const el: any = document.getElementById("text")
        saveSvgAsPng.saveSvgAsPng(el.children[0], `${title}-${domain}-${data.title}.png`, { encoderOptions: 1, scale });
    }

    const downloadSvg = () => {
        const el: any = document.getElementById("text")
        let mySvg = el.children[0].outerHTML;
        //svg转base64;
        let href =
            "data:image/svg+xml;base64," +
            window.btoa(unescape(encodeURIComponent(mySvg)));
        let image = new Image();
        image.src = href;
        //添加svg转base64格式的图片
        let svgImg = document.createElement("img");
        svgImg.src = href;
        svgImg.style.display = "none";
        document.body.appendChild(svgImg);
        //下载svg图片
        let svgLink = document.createElement("a");
        
        svgLink.download = `${title}-${domain}-${new Date().getTime()}.svg`; //图片名及格式
        svgLink.href = href;
        document.body.appendChild(svgLink);
        svgLink.target = "_new";
        svgLink.click();
    }

    const download = async () => {
        const res:any = await http(getFontItemUrl, { id: data._id })
        const { decrypted } = (await import('../../utils/rsa'))
        if (res.code == 200) {
            const href: any = decrypted(res.data.link);
            const a = document.createElement("a");
            a.href = href; //图片地址
            a.download = `${title}-${domain}-${data.title}.${href.split(".").pop().toLowerCase()}`
            document.body.appendChild(a);
            a.target = "_new";
            a.click();
        }

    }

    useEffect(() => {
        getFont()
    }, []);

    const footer = (
        <Row gutter={[16, 20]}>
            <Col span={24}> <TextArea value={text} onChange={textChange} placeholder="输入你想预览的文字" rows={3} /></Col>
            <Col flex="60px" style={{ lineHeight: '32px' }}>大小:</Col>
            <Col flex="auto"><Slider min={10} max={200} onChange={sizeChange} defaultValue={size} /></Col>
            <Col flex="90px">
                颜色:&nbsp;&nbsp;
                <Popover overlayClassName="color-choice" placement="bottom" title={null} content={<SketchPicker color={color} onChange={colorChange} />} trigger="click">
                    <Button type="primary" style={{ backgroundColor: color }} icon={<Down theme="outline" size="18" fill="#fff" strokeWidth={3} strokeLinejoin="miter" />} />
                </Popover>
            </Col>
            <Col style={{ textAlign: 'right' }} flex="110px">
                <Button type="primary" onClick={getFont}>
                    生成字体
                </Button>
            </Col>
            <Col span={24}>
                <Spin spinning={loading} tip="字体生成中...">
                    <Card size="small" title={data.title} extra={<>
                        <Space>
                            <Button onClick={() => { downloadImg(1) }} size="small" icon={<Download theme="outline" size="14" fill="#333" strokeWidth={3} strokeLinejoin="miter" strokeLinecap="butt" />}>
                                &nbsp;PNG
                            </Button>
                            <Button onClick={() => { downloadImg(3) }} size="small" icon={<Download theme="outline" size="14" fill="#333" strokeWidth={3} strokeLinejoin="miter" strokeLinecap="butt" />}>
                                &nbsp;PNG×3
                            </Button>
                            <Button onClick={downloadSvg} size="small" icon={<Download theme="outline" size="14" fill="#333" strokeWidth={3} strokeLinejoin="miter" strokeLinecap="butt" />}>
                                &nbsp;SVG
                            </Button>
                        </Space>

                    </>} style={{ width: '100%' }}>
                        <div style={{ maxWidth: '100%', overflow: 'auto' }} id="text" dangerouslySetInnerHTML={{ __html: image }}></div>
                    </Card>
                </Spin>

            </Col>
            <Col span={24} className="markdown-body works-cont">
                <h2>字体效果</h2>
                <p><img src={url + data.example} title={data.title} /></p>
                <div dangerouslySetInnerHTML={{ __html: data.html }}></div>
                <Text type="secondary">温馨提示:</Text>
                <br/>
                <Text type="secondary">
                    1、本站分享的所有字体，在发布之前都是经过多方查证的，在所有合法场景下都是可以免费商用的。但是，不排除版权方/作者某天又更改了授权许可方式，或者查证过程不小心有疏漏，所以，在实际商用时，建议联系版权方/作者再次核实，通过上面“参考资料”里面的链接一般可以找到版权方/作者。
                    对于这些有争议或有平台限制的免费商用字体，本站不会分享，以免误导。
                </Text>
            </Col>
        </Row>
    )

    return (
        <Layout head={head} styles={['/css/github.css', '/css/github-markdown.css']} className={styles.details}>
            <div className="content" style={{ paddingTop: '10px' }}>
                <PageHeader
                    title={data.title}
                    extra={[
                        <Button onClick={() => { download() }} key="Download" icon={<Download theme="outline" size="16" fill="#fff" strokeWidth={3} strokeLinejoin="miter" strokeLinecap="butt" />} type="primary">
                            &nbsp;下载字体
                        </Button>
                    ]}
                    footer={footer}
                >
                    <div className="main">{
                        <Descriptions size="small" column={isXs ? 2 : 3}>
                            <Descriptions.Item label="字体语言">{data.category_name}</Descriptions.Item>
                            <Descriptions.Item label="字体风格">{data.style_name}</Descriptions.Item>
                            <Descriptions.Item label="字体粗细">{data.weight_name}</Descriptions.Item>
                            {!isXs&&<Descriptions.Item label="时间"><Time theme="outline" size="16" fill="#999" strokeWidth={3} strokeLinejoin="miter" />&nbsp; {data.creat_date}</Descriptions.Item>}
                            <Descriptions.Item label="查看"><PreviewOpen theme="outline" size="18" fill="#999" strokeWidth={3} strokeLinejoin="miter" />&nbsp; {data.visit}</Descriptions.Item>
                            <Descriptions.Item label="下载"><Download theme="outline" size="18" fill="#999" strokeWidth={3} strokeLinejoin="miter" />&nbsp; {data.download_num}</Descriptions.Item>
                        </Descriptions>
                    }</div>
                </PageHeader>

            </div >
            <div className="content">
                <Title level={4}>相关推荐</Title>
                <List
                    itemLayout="vertical"
                    size="large"
                    dataSource={list}
                    footer={null}
                    grid={{
                        gutter: 0, xs: 1, sm: 3, md: 3, lg: 3, xl: 4, xxl: 4,
                    }}
                    renderItem={item => (
                        <List.Item style={{ padding: '10px 10px', marginBottom: 0 }}>
                            <Link href={{
                                pathname: '/font/[id]',
                                query: { id: item._id },
                            }} >
                                <a target="_blank" title={item.title}>
                                    <Card
                                        style={{ width: '100%', marginBottom: 0 }}
                                        cover={
                                            <img alt={item.title} src={url + item.img} />}
                                    >
                                        <Meta title={item.title} />
                                    </Card>
                                </a>
                            </Link>
                        </List.Item>
                    )}
                />
            </div>
        </Layout >
    )
}

FontId.getInitialProps = async ({ query, req }: NextPageContext) => {
    const res: any = await http(getFontItem, { id: query.id })
    return { data: res }
}

export default FontId